export const floatGallerySliding = (el) => {
  const { parent } = el
  const parentTop = parent.node.getBoundingClientRect().top
  const key = parseInt(parent.key)
  const acceleration = ((key << 3) % 5)
  const calcY = (parentTop / 10) * acceleration + 'px'
  el.node.style = `transform: translate3d(${acceleration * 25 - 30}px, ${calcY}, 1px)`
}
